import { FieldType, FormField, LufthansaContentOptions, LufthansaProductOptions, PROMPTS, WidthClass } from '@thehubz/client/core';

export const standardFields: FormField[] = [
  {
    formTypeId: '5',
    formFieldName: 'lufthansaContent',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Content`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    fieldGroup: 'tagging',
    value: undefined,
    dropDownSearch: true,
    options: LufthansaContentOptions,
    visible: false,
  },
  {
    formTypeId: '5',
    formFieldName: 'lufthansaProduct',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Product`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    fieldGroup: 'tagging',
    value: undefined,
    dropDownSearch: true,
    options: LufthansaProductOptions,
    visible: false,
  },
];
